import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Statistics from './pages/Statistics'; 
import './assets/app.css';
import { jwtDecode } from 'jwt-decode';


function App() {
  const [user, setUser] = useState(null);

  useEffect(() => {
      const token = localStorage.getItem('token');
      if (!token) return;

      try {
        const decoded = jwtDecode(token);

        const id = parseInt(decoded["http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier"]);
        const role = decoded["http://schemas.microsoft.com/ws/2008/06/identity/claims/role"];
        const username = decoded["http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name"];

        if (id && role && username) {
          setUser({ token, role, username, id });
        }
      } catch (err) {
        console.error("Ошибка декодирования токена:", err);
      }
    }, []);
 
  const handleLoginSuccess = (data) => {
    setUser(data);
  };

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('role');
    localStorage.removeItem('username');
    setUser(null);
  };
  
  if (!user) {
    return <Login onLoginSuccess={handleLoginSuccess} />;
  }
  
  return (
    <div className="background-wrapper" style={{ paddingLeft: '10px' }}> 
      <Router>
        <Routes>
          <Route path="/" element={<Dashboard user={user} />} />
          <Route path="/statistics" element={<Statistics user={user} />} />          
        </Routes>
      </Router>
           
      <button onClick={handleLogout} className="btn btn-danger">Выйти</button>
    </div>
    
    
    /*<div>      
      <Dashboard user={user} />
      
      <button onClick={handleLogout}>Выйти</button>
    </div>*/
  );
}

export default App;
